<script>
import axios from 'axios';

export default class LoginRepository {
   
    async doLogin(user){
        const baseURL =process.env.VUE_APP_API_URL;
        const headers = {
            'Content-Type': 'application/json',
        };
        const data = {
            username: user.username,
            password: user.password
        };
        const response = await axios.post(baseURL+'login', data, { headers: headers });
        return response;
    }
}
</script>